import { useState } from "react";
import { NavLink, Link } from "react-router-dom";
import { Menu, X } from "lucide-react";

const LINKS = [
  { to: "/", label: "Home" },
  { to: "/ebook", label: "The Book" },
  { to: "/cage-system", label: "Cage System" },
  { to: "/the-mission", label: "The Mission" },
  { to: "/about", label: "My Story" },
  { to: "/contact", label: "Contact" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);
  return (
    <header className="sticky top-0 z-50 backdrop-blur-md bg-white/85 border-b border-hairline" data-testid="site-header">
      <div className="max-w-screen-xl mx-auto px-6 md:px-12 flex items-center justify-between h-16">
        <Link to="/" className="flex items-center gap-1" aria-label="Return to Biology Trader homepage" data-testid="brand-link" onClick={() => setOpen(false)}>
          <span className="font-display text-lg md:text-xl leading-none tracking-tight text-ink" style={{ fontWeight: 800 }}>
            The Biology Trader
          </span>
          <span className="text-[10px] align-top text-[#245943] ml-0.5 mt-[-4px]">™</span>
        </Link>
        <nav className="hidden md:flex items-center gap-9" data-testid="desktop-nav">
          {LINKS.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              end={l.to === "/"}
              data-testid={`nav-${l.label.toLowerCase().replace(/\s/g, "-")}`}
              className={({ isActive }) =>
                `label-mono nav-link text-ink/90 hover:text-ink transition-colors ${isActive ? "is-active" : ""}`
              }
            >
              {l.label}
            </NavLink>
          ))}
        </nav>
        <button onClick={() => setOpen((v) => !v)} className="md:hidden p-2 -mr-2 text-ink" aria-label="toggle menu" data-testid="mobile-menu-toggle">
          {open ? <X size={20} /> : <Menu size={20} />}
        </button>
      </div>
      {open && (
        <div className="md:hidden border-t border-hairline bg-white" data-testid="mobile-menu">
          <nav className="flex flex-col px-6 py-6 gap-5">
            {LINKS.map((l) => (
              <NavLink key={l.to} to={l.to} end={l.to === "/"} onClick={() => setOpen(false)} data-testid={`mobile-nav-${l.label.toLowerCase().replace(/\s/g, "-")}`} className="label-mono text-ink">
                {l.label}
              </NavLink>
            ))}
          </nav>
        </div>
      )}
    </header>
  );
}
